import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AnimatePresence } from 'framer-motion'

interface Props {
  isOpen: boolean
  children: React.ReactNode
}

const AnimatedBox: React.FC<Props> = ({ isOpen, children }) => (
  <AnimatePresence>
    {isOpen && (
      <Box.Motion
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: 'auto', opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ opacity: { duration: 0.1 }, height: { duration: 0.3 } }}
        overflowY="hidden"
      >
        {children}
      </Box.Motion>
    )}
  </AnimatePresence>
)

export default AnimatedBox
